import React from 'react';
import ShipToMeTabPanel from './TabPanels/ShipToMeTabPanel';
import PickupInStoreTabPanel from './TabPanels/PickupInStoreTabPanel';
import { TabButtons, TabList } from './TabButtons';
import { IColorwayProductData, IVariant, TUserSelections } from '../../types/PDP';
import { getCookie, setCookie } from 'src/scripts/utils/cookies';

const PDPOmniTabsList: TabList = [
  { label: 'Ship to Me', value: 'ship_to_me' },
  { label: 'Pickup in Store', value: 'pickup_in_store' },
];

const selectedOmniTabCookieName = 'selectedOmniTab';

const PDPOmniTabs = ({
  shouldShowBopis,
  selectedVariant,
  quantityAvailable,
  product,
  userSelections,
}: {
  shouldShowBopis: boolean;
  selectedVariant: IVariant | undefined;
  quantityAvailable: number | undefined;
  product: IColorwayProductData;
  userSelections: TUserSelections;
}) => {
  const [activeTab, setTab] = React.useState(getCookie(selectedOmniTabCookieName) || 'ship_to_me');

  const onSelectTab = (value: string) => {
    setCookie(selectedOmniTabCookieName, value);
    setTab(value);
  };

  if (!shouldShowBopis) {
    return null;
  }

  return (
    <TabButtons tabList={PDPOmniTabsList} activeTab={activeTab} onSelectTab={onSelectTab}>
      {activeTab === 'pickup_in_store' ? (
        <PickupInStoreTabPanel
          selectedVariant={selectedVariant}
          quantityAvailable={quantityAvailable}
          product={product}
          userSelections={userSelections}
        />
      ) : (
        <ShipToMeTabPanel productTags={product.tags} />
      )}
    </TabButtons>
  );
};

export default PDPOmniTabs;
